import "../fonts.css";
import "react-toastify/dist/ReactToastify.css";
import "./global-style.css";

import { ApolloProvider } from "@apollo/client";
import { ConfigCatProvider, createFlagOverridesFromMap, OverrideBehaviour, PollingMode } from "configcat-react";
import { ReactElement, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { GenericTooltip, LoadingOverlayIndicator, MobileRestrictedModal } from "./components";
import container from "./container";
import { CONFIGCAT_CACHE_TTL_DEFAULT } from "./hooks";
import { CONFIGCAT_CACHE_TTL, CONFIGCAT_OVERRIDES, CONFIGCAT_SDK_KEY, USE_GRAPHQL_DEMO_DATA } from "./lib/env-helpers";
import { ModalProvider } from "./modal-provider";
import { AppRouter } from "./navigation/app-router";
import { DemoOktaProvider } from "./navigation/demo-okta-provider";
import { OktaSecurity } from "./navigation/okta-security";

const App = (): ReactElement => {
  return (
    <ConfigCatProvider
      sdkKey={CONFIGCAT_SDK_KEY}
      pollingMode={PollingMode.LazyLoad}
      options={{
        flagOverrides: createFlagOverridesFromMap(
          CONFIGCAT_OVERRIDES,
          USE_GRAPHQL_DEMO_DATA ? OverrideBehaviour.LocalOnly : OverrideBehaviour.LocalOverRemote,
        ),
        cacheTimeToLiveSeconds: Number(CONFIGCAT_CACHE_TTL) || CONFIGCAT_CACHE_TTL_DEFAULT,
      }}
    >
      <ApolloProvider client={container.apolloClient}>
        <ToastContainer />
        <BrowserRouter>
          <ModalProvider>
            <Suspense fallback={<LoadingOverlayIndicator />}>
              {USE_GRAPHQL_DEMO_DATA ? (
                <DemoOktaProvider>
                  <AppRouter />
                </DemoOktaProvider>
              ) : (
                <OktaSecurity>
                  <AppRouter />
                </OktaSecurity>
              )}
            </Suspense>
          </ModalProvider>
        </BrowserRouter>
        <GenericTooltip />
        <MobileRestrictedModal />
      </ApolloProvider>
    </ConfigCatProvider>
  );
};

export default App;
